import { useContext } from "react";

import { MultiLayerEditContext } from "./MultiLayerEditProvider";
import { MultiLayerEditLegacyContext } from "./MultiLayerEditProviderLegacy";

/**
 * Hook to access multi-layer edit context.
 * Must be used within a MultiLayerEditProvider or MultiLayerEditLegacyProvider.
 */
export const useMultiLayerEdit = () => {
  const context = useContext(MultiLayerEditContext);
  const legacyContext = useContext(MultiLayerEditLegacyContext);

  const activeContext = context || legacyContext;

  if (!activeContext) {
    throw new Error("useMultiLayerEdit must be used within a MultiLayerEditProvider or MultiLayerEditLegacyProvider");
  }
  return activeContext;
};
